angular.module('webcomm')
    .directive('presenceTable', function () {
        return {
            templateUrl: 'app/main/channel/presence/presenceTable.html',
            replace: true,
            controller: 'PresenceTableController'
        };
    })
    .controller('PresenceTableController', [
        '$log',
        '$scope',
        'userService',
        'channelModel',
        'privateCallService',
        'endpointModel',
        function ($log, $scope, userService, channelModel, privateCallService, endpointModel) {

            var _myUserInfo;

            function reloadUsers(users) {
                $scope.users = users || userService.getUsers();

                _myUserInfo = userService.getUser(endpointModel.getMyEndpoint().userName);
            }

            $scope.publicTalkgroup = channelModel.getSelectedChannel() ? channelModel.getSelectedChannel().id >= 0 : true;

            $scope.showCallButton = (user) => {

                return user.privateCallEnabled &&
                    !privateCallService.activeCallExists() &&
                    _myUserInfo &&
                    _myUserInfo.callAlias &&
                    _myUserInfo.disposition !== 'phone';
            };

            $scope.presenceTableLocationClick = (user) => {
                $scope.$emit('presenceTableController.locationPinClicked', user.location);

                if(!user.self) {
                    user.getNextLocation();
                }
            };

            $scope.openPrivateTalkgroup = (user, call) => {
                channelModel.addOrUpdateAndSelectPrivateCallChannel(_myUserInfo, user);

                if (call) {
                    $scope.callEndpoint(user);
                }
                else {
                    $scope.$emit('map.closeFullscreenMap');
                }
            };

            $scope.callEndpoint = (user) => {
                $scope.$emit('map.closeFullscreenMap');

                privateCallService
                    .callRequest(user.callAlias, user.userName, user.displayName)
                    .then((resp) => $scope.$emit('makingCall', resp))
                    .catch(err => $log.error(err));
            }

            var unbindUserJoined = $scope.$on('userService.userJoined', (event, user) => {
                reloadUsers();
            });

            var unbindUserLeft = $scope.$on('userService.userLeft', (event, user) => {
                reloadUsers();
            });

            var unbindPresenceUpdated = $scope.$on('userService.userUpdated', (event, user) => {
                    // this seems to be a good spot to trigger panel resizing - its the only on that seems to work for FF
                    // this means it gets resized every time an endpoint gets added/changes :(
                    // TODO: find a better place,
                    $scope.$evalAsync(() => {
                        $scope.$emit('timeForResize');
                    });

                reloadUsers();
            });

            var unbindUsersLoaded = $scope.$on('userService.usersLoaded', (event, users) => {
                reloadUsers(users);
            });

            var unbindChannelSelected = $scope.$on('channelModel.channelSelected', (e, channel) => {
                $scope.publicTalkgroup = channel.id < 0 ? false : true;
                $scope.users.length = 0;
            });

            $scope.$on('$destroy', function () {
                unbindPresenceUpdated();
                unbindUserJoined();
                unbindUserLeft();
                unbindUsersLoaded();
                unbindChannelSelected();
                $log.debug('PresenceTableController destroyed');
            });

            reloadUsers();
        }]);
     